@if (showEachWayButton && !(freeBetToken$ | async)) {
    <button
        class="summary-stake-eachway-price-button"
        [class.selected]="isEachWaySelected || buttonDisable"
        [disabled]="buttonDisable"
        (click)="onEachWayClick($event)">
        {{ title }}
    </button>
}
@if (showEachWayText) {
    <span class="summary-stake-eachway-price-text">2x</span>
}
@if (freeBetToken$ | async; as freeBet) {
    <bs-freebet-stake [freeBetToken]="freeBet" />
} @else {
    <ms-stake [stake]="stakeAsStr" [errors]="hasStakeError$" [keypadId]="keypadId" [numpadSource]="numpadSource" (stakeChanged)="setStake($event)" />
}
